import { TextField, Typography } from '@mui/material';

const StyledFilledTextField = (props) => {
    let helperText = props.helperText;
    let textFieldProps = { ...props };
    if (props.helperText) {
        delete textFieldProps.helperText;
    }

    return (
        <>
            <TextField
                {...textFieldProps}
                variant="filled"
                InputProps={{ disableUnderline: true, ...props.InputProps }}
                // Border and radius come from the MuiFilledInput theme override
                sx={props.sx}
            />
            {helperText && <Typography sx={{ fontSize: 12, color: `${textFieldProps.error ? 'red' : '#747475'} !important` }}>{helperText}</Typography>}
        </>
    );
};

export default StyledFilledTextField;
